// extracted by mini-css-extract-plugin
module.exports = {"empty":"EmptyPage_empty__Naycq"};